import { type BoxProps, Center, Spinner } from "@chakra-ui/react";
import { useEffect, useState } from "react";

/**
 * データの読み込み等で使用する。
 * withDelay を指定すると、指定したミリ秒後に表示される。
 */
export const LoadingBox = (
  props: BoxProps & { size?: "screen"; withDelay?: number },
) => {
  const { withDelay = 0 } = props;
  const [isVisible, setIsVisible] = useState(typeof withDelay !== "number");

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, withDelay);
    return () => clearTimeout(timer);
  }, [withDelay]);

  return (
    <Center py="64px" {...props} visibility={isVisible ? "visible" : "hidden"}>
      <Spinner
        animationDuration="0.6s"
        width="48px"
        height="48px"
        color="semantic.core.secondary"
        borderWidth="4px"
        css={{ "--spinner-track-color": "rgba(74, 85, 104, 0.2)" }}
      />
    </Center>
  );
};
